import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { docsMarkdownComponentsMap } from './docs-markdown-components-map';

interface DocsMarkdownProps {
  content: string;
}

export function DocsMarkdown({ content }: DocsMarkdownProps) {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={docsMarkdownComponentsMap}>
      {content}
    </ReactMarkdown>
  );
}
